import { createAction, props } from '@ngrx/store';
import {
  CreateResponsibleOfficialPayload,
  ResponsibleOfficial,
  UpdateResponsibleOfficialPayload,
} from 'brain-data/model/responsible-official.model';

export const loadResponsibleOfficials = createAction('[ResponsibleOfficials] load');
export const loadResponsibleOfficialsSuccess = createAction(
  '[ResponsibleOfficials] load success',
  props<{ officials: ResponsibleOfficial[] }>(),
);
export const loadResponsibleOfficialsError = createAction(
  '[ResponsibleOfficials] load error',
  props<{ error: Error }>(),
);

export const createResponsibleOfficial = createAction(
  '[ResponsibleOfficials] create',
  props<{ payload: CreateResponsibleOfficialPayload }>(),
);
export const createResponsibleOfficialSuccess = createAction(
  '[ResponsibleOfficials] create success',
  props<{ official: ResponsibleOfficial }>(),
);
export const createResponsibleOfficialError = createAction(
  '[ResponsibleOfficials] create error',
  props<{ error: Error }>(),
);

export const updateResponsibleOfficial = createAction(
  '[ResponsibleOfficials] update',
  props<{ id: number; payload: UpdateResponsibleOfficialPayload }>(),
);
export const updateResponsibleOfficialSuccess = createAction(
  '[ResponsibleOfficials] update success',
  props<{ official: ResponsibleOfficial }>(),
);
export const updateResponsibleOfficialError = createAction(
  '[ResponsibleOfficials] update error',
  props<{ error: Error }>(),
);

export const deleteResponsibleOfficial = createAction(
  '[ResponsibleOfficials] delete',
  props<{ id: number }>(),
);
export const deleteResponsibleOfficialSuccess = createAction(
  '[ResponsibleOfficials] delete success',
  props<{ id: number }>(),
);
export const deleteResponsibleOfficialError = createAction(
  '[ResponsibleOfficials] delete error',
  props<{ error: Error }>(),
);
